import { render, staticRenderFns } from "./SessaoView.vue?vue&type=template&id=c6b4ad7c&"
import script from "./SessaoView.vue?vue&type=script&lang=js&"
export * from "./SessaoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports